import React from 'react'
import {
  View,
  Platform,
  ScrollView,
  TextInput,
  TouchableOpacity,
  FlatList,
  ListRenderItem,
  ListRenderItemInfo,
  LayoutChangeEvent,
  Dimensions,
  RefreshControl,
} from 'react-native'
import VStack from 'xui/components/VStack'
import Box from 'xui/components/Box'
import HStack from 'xui/components/HStack'

import _ from 'lodash'
import moment, { Moment } from 'moment'
import { List, Map } from 'immutable'

import p from 'x/config/platform-specific'
import api from 'x/utils/api'
import { S, COLORS, PRODUCT_LIST_ITEM_WIDTH } from 'x/config/styles'
import CONS from 'x/config/constants'
import {
  IProductListViewProps,
  IProductListViewState,
  IProductItemData,
  ICategory,
  categoryByStore,
  IProductDetailItem,
  IApiOptions,
  IBarcodeScannerOutput,
  IAnyObject,
  IProductListFilterState,
  IProductListFilterTemplate,
} from 'x/index'
import * as acl from 'x/utils/acl'
import * as util from 'x/utils/util'
import * as NavActions from 'x/utils/navigation'
import NB from 'x/config/nativebase'

import XSpinner from 'xui/components/XSpinner'
import ErrorListItem from 'xui/components/ErrorListItem'
import BarcodeScannerModalButton from 'xui/components/BarcodeScannerModalButton'
import XIconButton from 'xui/components/XIconButton'
import ProductCategorySelector from 'xui/components/product/ProductCategorySelector'
import XText from 'xui/components/XText'
// import ProductListFilterView from 'xui/components/ProductListFilterView'
import { diff } from 'deep-object-diff'
import InfiniteList, { InfiniteListBase } from '../../components/InfiniteList'
import ProductListItem from './ProductListItem'
import XIcon from '../../components/XIcon'
import XStatusBar from '../../components/XStatusBar'
import NavHeaderButton from '../../components/NavHeaderButton'
import ButtonClose from '../../components/ButtonClose'
import XInput from '../../components/XInput'
import XContainer from '../../components/XContainer'
// import XCustomHeader from '../../components/XCustomHeader'

// หน่วงเวลาการ search หลังจากพิมพ์เสร็จ
const SEARCH_TYPING_DELAY = 700
// หน่วงเวลาที่จะสามารถ search ด้วย keyword เดิมได้
const SEARCH_LATEST_KEYWORD_TIMEOUT = 5000

const MINIMUM_SEARCH_TEXT_LENGTH = 2

const DEVICE_WIDTH = p.op.isWeb() ? 320 : Dimensions.get('screen').width

// interface IDefaulltNavParams {
//   store_id?: number
//   seller_store_id?: number
// }

const { PULL_PRODUCT, VIEW_SELLER, PULL_SELLER_PRODUCT_TO_ORDER, MKP_MAPPING } = CONS.PRODUCT_VIEW_MODE

const viewabilityConfig = {
  itemVisiblePercentThreshold: 50,
}

abstract class BaseUIProductListView<
  IProps extends IProductListViewProps,
  IState extends IProductListViewState,
  ProductListItemType extends IProductItemData = IProductItemData,
> extends React.Component<IProps, IState> {
  static displayName = 'BaseUIProductListView'

  // เมื่อกด ProductListItem
  abstract onPressProductItem?(item: { index?: number; data: ProductListItemType }): void | Promise<void>

  inNavigationProcess?: boolean

  isInitFetching?: boolean

  // drawerCatRef?: React.RefObject<ProductListFilterView>

  mainListRef: React.RefObject<InfiniteListBase<ProductListItemType>>

  searchListRef: React.RefObject<InfiniteListBase<ProductListItemType>>

  searchTextRef: React.RefObject<TextInput>

  productCategoryScrollRef?: React.RefObject<ScrollView>

  productCategoryScrollableMaxX?: number

  productCategoryLastScrollX?: number

  returnCategoryInfo: boolean

  lastSearchText: string

  lastSearchTypingDateTime?: Moment

  lastSearchSuccessDateTime?: Moment

  lastSearchRefreshQueueTimeout?: NodeJS.Timeout

  lastSearchTimeout?: NodeJS.Timeout

  isRefreshing?: boolean

  isFetching?: boolean

  contentWidth: number

  listItemWidth: number

  isScrolling?: boolean

  constructor(props) {
    super(props)

    // this.drawerCatRef = React.createRef()
    this.mainListRef = React.createRef()
    this.searchListRef = React.createRef()
    this.searchTextRef = React.createRef()
    this.productCategoryScrollRef = React.createRef()

    this.productCategoryLastScrollX = 0
    this.returnCategoryInfo = false

    this.lastSearchText = ''

    this.contentWidth = DEVICE_WIDTH
    this.listItemWidth = this._computeListItemWidth()

    // https://github.com/microsoft/TypeScript/issues/10761
    // @ts-ignore อาจจะมี generic state เพิ่มเข้ามาอีกภายหลัง
    this.state = {
      isInitialized: false,
      searchText: '',
      mainProductCount: null,
      mainProductNumOfColumns: 1,
      searchProductCount: null,
      isBarcodeSearching: false,
      isBarcodeCameraVisible: false,

      contentWidth: this.contentWidth,
      listColumns: this._computeListColumns(),
      listViewMode: 'grid', // 'grid' | 'list'
      checkedProductListItem: {}, // { [productId: number]: boolean }

      mainProductListItems: [],
      searchProductListItems: [],
      // mainProductListItemCount: null,
      // searchProductListItemCount: null,
      mainIsLoadingByOffset: {},
      searchIsLoadingByOffset: {},

      mainFetchErrorMessage: null,
      searchFetchErrorMessage: null,

      catLevelCategoryList: null,
      catSeletedCategory: null,
      catSupCategory: null,
      allChildrenCategory: true,

      productCategoryScrollViewProperties: {
        currentWidth: 320,
        isVisibleScrollToBeginButton: false,
        isVisibleScrollToEndButton: false,
      },
      // mkp_ch_ids: [],

      // sortOptions: CONS.DEFAULT_PRODUCT_LIST_SORT_OPTIONS,

      filterState: {},
    }
  }

  // Lifecycle
  async componentDidMount() {
    const savedListViewMode = await p.op.storageGet('ProductListView_listViewMode', false)
    if (_.isString(savedListViewMode)) {
      await util.setStatePromise(this, { listViewMode: savedListViewMode })
    }

    await this._setupFilter()
    // console.log('ProductListView componentDidMount => ', this.mainListRef.current)
    await this._configCategory()
    await util.setStatePromise(this, { isInitialized: true })
    await this._handleRefresh()
  }

  _setupFilter = async () => {
    const defaultFilter = this.getDefautProductListFilterState()
    await util.setStatePromise(this, { filterState: defaultFilter })
  }

  // External availble Methods

  // // เป็นการ access ร้านขายส่งรึเปล่า (override ทับได้)
  // isSellerStore = () => false

  // ทำการ search
  isSearching = () => this.state.searchText.length >= 2

  // สลับ list เป็น search list แต่อาจจะ search แล้วหรือไม่ก็ได้
  isSearchMode = () => this.state.searchText.length > 0

  isHiddenMainProductList = () => this.isSearchMode()

  isHiddenSearchProductList = () => !this.isSearching()

  isOmitStockQty = () => false

  // ใช้เช็คว่า ProductListView นั้นพร้อมในการทำงานต่างๆ หรือยัง โดยอิงจาก initial fetch สำเร็จ จะได้ count กลับมา
  isProductListViewReady = () => _.isNumber(this.state.mainProductCount)

  isChangeRenderModeButtonVisible = () => true

  isAddProductButtonVisible = () => true

  isRequiredProductVariants = () => false

  isUpcSearchAvailable = () => true

  isSkuSearchAvailable = () => {
    const { selectedStore } = this.props
    return selectedStore.get(CONS.STORE_SETTINGS.COMPUTED_USE_PRODUCT_SKU)
  }

  isProductListItemPressDisabled = () => false

  isProductListItemSellerIconDisabled = () => false

  isProductListItemPriceDisabled = () => false

  isProductListItemQtyDisabled = () => false

  // หลังจาก search เสร็จสิ้น ได้ response มาแล้วจะทำอะไรก่อนหรือไม่?
  onAfterFetchSeachProducts = async (
    fetchedData: { count?: number; items: ProductListItemType[] },
    requestBody: IAnyObject
  ): Promise<void> => {
    // no-op
  }

  getApiEndpoint = () => api.POST_PRODUCTS

  isGoApi = () => false

  getIsGoBackButtonHidden = (): boolean => {
    const { navigation } = this.props
    return util.getNavParam(this.props, 'isGoBackButtonHidden', false)
  }

  getTargetStoreId = () => {
    const { navigation } = this.props
    const storeId = util.getNavParam(this.props, 'store_id')
    // if (this.isSellerStore()) {
    //   storeId =util.getNavParam(this.props, 'seller_store_id')
    // } else {
    //   storeId =util.getNavParam(this.props, 'store_id')
    // }
    if (typeof storeId !== 'number') {
      throw new Error('store_id is required')
    }
    return storeId
  }

  // Bad function ไม่ควรอยู่ตรงนี้
  handleOnPullProductToOrderSuccess = (newState: Map<string, any>): void => {
    // log('success callback of quick add => newState.toJS()', newState.toJS())
    const store_products = newState.getIn(['editingOrder', 'store_products']) || null
    const store_ids = store_products.keySeq().toArray() || []
    // log('success callback of quick add => store_ids', store_ids)
    if (store_products && store_ids.length > 0) {
      let products = List([])
      for (let sIdx = 0; sIdx < store_ids.length; sIdx++) {
        const sId = store_ids[sIdx]
        const sProds = store_products.get(sId) || List([])
        products = products.concat(sProds)
      }

      let txtSummary = ''
      for (let i = 0; i < products.size; i++) {
        if (i === 0) {
          txtSummary = 'สินค้าในออเดอร์ทั้งหมด\n'
        }
        const product = products.get(i)
        const name = product.get('name')
        const variant = product.get('variant')
        const qty = product.get('qty')
        const txtProductName = variant ? `${name} (${variant})` : name
        txtSummary += `\n${txtProductName} x${qty}`
      }
      // showSuccessToast(`เพิ่ม ${txtProductName} แล้ว`)
      if (txtSummary) {
        p.op.showToast(txtSummary, 'success')
      }
    }
  }

  // getSellerStoreId = () => {
  //   const sellerStoreId = this.props.navigation.getParam('seller_store_id')
  //   if (typeof sellerStoreId !== 'number') {
  //     throw new Error('seller_store_id is required')
  //   }
  //   return sellerStoreId
  // }

  getHaveNoProductItemText = () => 'ไม่พบรายการสินค้า'

  getSearchProductListHaveNoProductItemText = () => 'ไม่พบรายการสินค้าที่ค้นหา'

  // should Override on Web:: เอาไว้คำนวณขอบเขตพื้นที่ของ ProductView
  // getScreenWidth = (): number => {
  //   return Dimensions.get('screen').width
  // }

  // เลือก reference ทีั่จะสั่งอัตโนมัติตาม search mode ว่าถ้าหาก user พิมพ์เพื่อ search จะไปใช้งาน searchListRef
  getFocusProductListRef = () => {
    if (this.isSearchMode()) {
      return this.getSearchProductListRef()
    }
    return this.getMainProductListRef()
  }

  getSearchProductListRef = () => this.searchListRef.current

  getMainProductListRef = () => this.mainListRef.current

  fetchMainProducts = async ({ offset, limit }) => {
    type FetchedData = {
      count?: number
      items: ProductListItemType[]
    }
    let requestBody = this.getCommonRequestBody({ offset, limit })
    requestBody = this.getModifiedRequestBody(requestBody)
    const fetchedData: FetchedData = await this.doFetchProducts(requestBody)
    return fetchedData
  }

  fetchSearchProducts = async ({ offset, limit }) => {
    type FetchedData = {
      count?: number
      items: ProductListItemType[]
    }
    let requestBody = this.getCommonRequestBody({ offset, limit })
    requestBody.queryTxt = this.state.searchText
    requestBody = this.getModifiedRequestBody(requestBody)
    const fetchedData: FetchedData = await this.doFetchProducts(requestBody)
    await this.onAfterFetchSeachProducts(fetchedData, requestBody)
    return fetchedData
  }

  // 1. เตรียม request body เบื้องต้่น
  getCommonRequestBody = ({ offset, limit }) => {
    let body: any = {
      store_id: this.getTargetStoreId(),
      offset,
      limit,
      sortBy: 'updated_at',
      sortType: 'desc',
    }

    // if (this.isSellerStore()) {
    //   body.store_id = this.getSellerStoreId()
    // }

    // fetch count only first time
    if (offset === 0) {
      body.c = 1
    }
    // fetch product variants ?
    if (this.isRequiredProductVariants()) {
      body.v = 1
    }

    if (this.isOmitStockQty()) {
      body.omit_stock_qty = true
    }

    body = this._applyRoleIdToRequestBody(body)

    const {
      // catSeletedCategory,
      // allChildrenCategory,
      isBarcodeSearching = false,
      // mkp_ch_ids = [],
      // sortOptions,
      filterState = {},
      // filterOptions = {},
    } = this.state

    // const filterOptions = this.getFilterOptionsFromState(filterState)
    const filterOptions = util.translateProductListFilterToRequestBody(filterState)

    // const selectedCatehory = catSeletedCategory
    // if (!_.isNil(selectedCatehory)) {
    //   body.category_id = selectedCatehory.id
    //   body.withSubCategories = allChildrenCategory
    // }

    // if (this.returnCategoryInfo) {
    //   body.returnCategoryInfo = true
    //   this.returnCategoryInfo = false
    // }

    if (isBarcodeSearching) {
      if (this.isSkuSearchAvailable()) {
        body.isSKU = true
      }
      if (this.isUpcSearchAvailable()) {
        body.isUPC = true
      }
    }

    // if (mkp_ch_ids.length > 0) {
    //   body.mkp_ch_ids = mkp_ch_ids
    // }

    // if (sortOptions.sortBy) {
    //   body.sortBy = sortOptions.sortBy
    // }

    // if (sortOptions.sortType) {
    //   body.sortType = sortOptions.sortType
    // }

    if (!_.isEmpty(filterOptions)) {
      body = { ...body, ...filterOptions }
    }

    return body
  }

  // 2. เอาไว้ modify request body สำหรับ view ที่ extends ออกไป
  getModifiedRequestBody = (body) => body

  // 3. อันนี้คือ logic สั่งยิง fetch
  doFetchProducts = async (requestBody) => {
    const apiOptions: IApiOptions = {
      axiosOptions: {
        retry: 0,
        timeout: 60000,
      },
      isErrorAlertDisabled: true,
    }
    // console.log('requestBody ->  ', requestBody)
    if (this.isGoApi()) {
      apiOptions.isApiV2 = true
    }
    const fetchedData = {
      count: undefined,
      items: [],
    }
    try {
      const res = await api.post(this.getApiEndpoint(), requestBody, apiOptions)
      if (!res || _.isEmpty(res)) {
        // FIXME: แค่ mock error เพราะดันมี {} กลับมาหลังจาก no internet connection โดยไม่ throw error
        throw {
          statusCode: 503,
          errorMessage: 'Service Unavailable',
        }
      }
      // console.log('doFetchProducts res => ', res)
      if (typeof res.count === 'number') {
        fetchedData.count = res.count
      }
      if (res.products) {
        fetchedData.items = res.products
      }
    } catch (err) {
      // console.log('doFetchProducts err => ', err)
      // console.error('doFetchProducts err => ', err)
      // console.log(JSON.parse(JSON.stringify(err)))
      if (requestBody.offset === 0) {
        if (requestBody.queryTxt) {
          await util.setStatePromise(this, { searchFetchErrorMessage: util.getErrorMessageFromErrorResponse(err) })
        } else {
          await util.setStatePromise(this, { mainFetchErrorMessage: util.getErrorMessageFromErrorResponse(err) })
        }
      }
    }

    return fetchedData
  }

  // can be override
  getDefautProductListFilterState = () => {
    const defaultFilter: IProductListFilterState = util.getNavParam(this.props, 'defaultFilter', {})
    defaultFilter.isProductTemplateFilter = true
    return defaultFilter
  }

  // getFilterOptionsFromState = (fs: IProductListFilterState): IProductListFilterOptions => {
  //   const {
  //     category,
  //     // mkpChIds,
  //     segmentCreatedAtIndex,
  //     createdAtFrom,
  //     createdAtTo,
  //     createdAtRangeOptionKey,
  //     segmentUpdatedAtIndex,
  //     updatedAtFrom,
  //     updatedAtTo,

  //     segmentHasMkpChIndex,
  //     segmentHasMkpChNotInIndex,
  //     mkpChannelActiveMap,
  //     mkpChannelNotInActiveMap,

  //     segmentHasParentIndex,
  //     segmentHasCreatedByMkpChIndex,
  //     hasCreatedByMkpChIds,
  //     segmentHasCreatedByMkpChSpecificIndex,
  //   } = fs

  //   const fo: IProductListFilterOptions = {}

  //   if (segmentCreatedAtIndex === 1 && createdAtFrom && createdAtTo) {
  //     fo.created_at_from = createdAtFrom.format(CONS.SERVER_DATETIME_FORMAT)
  //     fo.created_at_to = createdAtTo.format(CONS.SERVER_DATETIME_FORMAT)
  //   }

  //   if (segmentUpdatedAtIndex === 1 && updatedAtFrom && updatedAtTo) {
  //     fo.updated_at_from = updatedAtFrom.format(CONS.SERVER_DATETIME_FORMAT)
  //     fo.updated_at_to = updatedAtTo.format(CONS.SERVER_DATETIME_FORMAT)
  //   }

  //   // if (segmentHasMkpChIndex === 1) {
  //   //   fo.has_mkp_ch = false
  //   // }

  //   // if (segmentHasMkpChIndex === 2) {
  //   //   fo.has_mkp_ch = true
  //   // }

  //   // if (segmentHasMkpChIndex === 2 && mkpChIds && mkpChIds.length > 0) {
  //   //   fo.mkp_ch_ids = mkpChIds
  //   // }

  //   if (segmentHasMkpChIndex === 1 && _.isObject(mkpChannelActiveMap) && !_.isEmpty(mkpChannelActiveMap)) {
  //     const mkp_ch_ids = Object.keys(mkpChannelActiveMap)
  //       .filter((mkpChId) => mkpChannelActiveMap[mkpChId])
  //       .map((mkpChId) => parseInt(mkpChId))

  //     if (mkp_ch_ids && mkp_ch_ids.length > 0) {
  //       fo.mkp_ch_ids = mkp_ch_ids
  //     }
  //   }

  //   if (segmentHasMkpChNotInIndex === 1 && _.isObject(mkpChannelNotInActiveMap) && !_.isEmpty(mkpChannelNotInActiveMap)) {
  //     const mkp_ch_ids_not_in = Object.keys(mkpChannelNotInActiveMap)
  //       .filter((mkpChId) => mkpChannelNotInActiveMap[mkpChId])
  //       .map((mkpChId) => parseInt(mkpChId))

  //     if (mkp_ch_ids_not_in && mkp_ch_ids_not_in.length > 0) {
  //       fo.mkp_ch_ids_not_in = mkp_ch_ids_not_in
  //     }
  //   }

  //   if (segmentHasParentIndex === 1) {
  //     fo.has_parent = true
  //   }

  //   if (segmentHasParentIndex === 2) {
  //     fo.has_parent = false
  //   }

  //   if (segmentHasCreatedByMkpChIndex === 1) {
  //     fo.has_created_by_mkp_ch = false
  //   }

  //   if (segmentHasCreatedByMkpChIndex === 2) {
  //     fo.has_created_by_mkp_ch = true
  //   }

  //   if (segmentHasCreatedByMkpChSpecificIndex === 1 && hasCreatedByMkpChIds && hasCreatedByMkpChIds.length > 0) {
  //     fo.created_by_mkp_ch_ids = hasCreatedByMkpChIds
  //   }

  //   return fo
  // }

  generateEmptyItems = (n: number) => {
    const emptyItem = {
      isEmpty: true,
      // id: null,
      // n: '',
    }

    const items = []
    for (let i = 0; i < n; i++) {
      items.push(emptyItem)
    }
    return items
  }

  setCount = async (isSearchMode: boolean, count: number | null) => {
    const { mainProductListItems, searchProductListItems } = this.state
    if (isSearchMode) {
      await util.setStatePromise(this, { searchProductCount: count, hasLoadMore: count > searchProductListItems.length })
    } else {
      await util.setStatePromise(this, { mainProductCount: count, hasLoadMore: count > mainProductListItems.length })
    }
  }

  // Count ของ items ที่มีอยู่ในปัจจุบัน
  getItemCount = () => {
    const { mainProductListItems, searchProductListItems } = this.state
    const items = this.isSearchMode() ? searchProductListItems : mainProductListItems
    return items.length
  }

  // Count สูงสุดที่ api ส่งมาให้
  getTotalCount = () => {
    const { mainProductCount, searchProductCount } = this.state
    return this.isSearchMode() ? searchProductCount : mainProductCount
  }

  loadProductListItems = async (newItems: ProductListItemType[], offset: number, isSearchMode = false) => {
    const { mainProductListItems, searchProductListItems, searchProductCount, mainProductCount } = this.state
    let items
    if (offset === 0) {
      items = []
    } else {
      items = isSearchMode ? [...searchProductListItems] : [...mainProductListItems]
    }

    let hasLoadMore = true
    const count = isSearchMode ? searchProductCount : mainProductCount
    // const hasEnoughSlot = items.length >= offset + newItems.length
    // const removeNum = hasEnoughSlot ? newItems.length : items.length - offset
    // items.splice(offset, removeNum, ...newItems)

    if (typeof count === 'number' && items.length > count) {
      items.length = count
    }
    items = items.concat(newItems)

    if (newItems.length === 0 || (typeof count === 'number' && items.length >= count)) {
      hasLoadMore = false

      // if (items.length > 0 && items.length < count) {
      //   const genNum = count - items.length > 20 ? 20 : count - items.length
      //   items = items.concat(this.generateEmptyItems(genNum))
      // }
    }

    if (isSearchMode) {
      await util.setStatePromise(this, { searchProductListItems: items, hasLoadMore })
    } else {
      await util.setStatePromise(this, { mainProductListItems: items, hasLoadMore })
    }
  }

  setIsLoadingByOffset = async (isSearchMode: boolean, isLoading: boolean, offset: number, limit = 0) => {
    const {
      mainIsLoadingByOffset,
      searchIsLoadingByOffset,
      mainProductCount,
      searchProductCount,
      searchProductListItems,
      mainProductListItems,
    } = this.state
    const isLoadingByOffset = isSearchMode ? _.cloneDeep(searchIsLoadingByOffset) : _.cloneDeep(mainIsLoadingByOffset)

    isLoadingByOffset[offset] = isLoading
    const count = isSearchMode ? searchProductCount : mainProductCount
    let items = isSearchMode ? [...searchProductListItems] : [...mainProductListItems]

    if (limit) {
      let predictedLength = offset + limit
      if (typeof count === 'number' && predictedLength > count) {
        predictedLength = count
      }

      if (items.length > 0 && items.length < predictedLength) {
        items = items.concat(this.generateEmptyItems(predictedLength - items.length))
      }
    }

    if (isSearchMode) {
      await util.setStatePromise(this, { searchIsLoadingByOffset: isLoadingByOffset, searchProductListItems: items })
    } else {
      await util.setStatePromise(this, { mainIsLoadingByOffset: isLoadingByOffset, mainProductListItems: items })
    }
  }

  _fetchItems = async (options: { offset?: number; isLoadMore?: true; isSearchMode?: boolean } = {}) => {
    const fetchLimit = 20
    const {
      mainProductListItems,
      searchProductListItems,
      mainIsLoadingByOffset,
      searchIsLoadingByOffset,
      searchProductCount,
      mainProductCount,
      searchText,
    } = this.state

    const isSearchMode = options.isSearchMode || false

    if (isSearchMode && searchText.length < MINIMUM_SEARCH_TEXT_LENGTH) {
      // ถ้าหากเป็น search mode แต่ search text น้อยกว่า 2 ตัวอักษร
      // ไม่ต้อง fetch อะไรทั้งนั้น
      return
    }

    const items = isSearchMode ? searchProductListItems : mainProductListItems
    const isLoadingByOffset = isSearchMode ? searchIsLoadingByOffset : mainIsLoadingByOffset
    const count = isSearchMode ? searchProductCount : mainProductCount

    // คำนวณ​ fetchOffset โดยอิงจาก fetchLimit โดยปัดให้ลงตัว
    // const computeOffsetByLimit = Math.floor(items.length / fetchLimit) * fetchLimit
    // const fetchOffset = _.has(isLoadingByOffset, options.offset) ? options.offset : computeOffsetByLimit
    // const fetchOffset = items.length
    const fetchOffset = _.isNumber(options.offset) ? options.offset : items.length

    const firstOffsetItem = items[fetchOffset]
    if (options.isLoadMore && firstOffsetItem && !firstOffsetItem.isEmpty) {
      // ถ้าหากเป็นการ fetch more แล้่วใน item ไม่ใช่ empty item ดังนั้นควร ignore fetch
      return
    }

    if (_.has(isLoadingByOffset, fetchOffset) && isLoadingByOffset[fetchOffset]) {
      // ถ้าหากมีการ fetching ใน offset นี้อยู่ ควร ignore อันที่จะมาใหม่
      return
    }

    // await this.setIsLoadingByOffset(isSearchMode, true, fetchOffset, fetchLimit)

    try {
      const doFetch = isSearchMode ? this.fetchSearchProducts : this.fetchMainProducts
      const fetchedData = await doFetch({ offset: fetchOffset, limit: fetchLimit })

      if (typeof fetchedData.count === 'number') {
        await this.setCount(isSearchMode, fetchedData.count)
        // this._updateCountToParent(fetchedData.count)
      } else if (
        !_.isNumber(count) &&
        !_.isNumber(fetchedData.count) &&
        _.isArray(fetchedData.items) &&
        fetchedData.items.length > 0 &&
        fetchedData.items.length < fetchLimit
      ) {
        const newCount = this.getItemCount() + fetchedData.items.length // local เก่า + new items ใหม่
        await this.setCount(isSearchMode, newCount)
        // this._updateCountToParent(newCount)
      } else if (!_.isNumber(count) && !_.isNumber(fetchedData.count) && _.isArray(fetchedData.items) && fetchedData.items.length === 0) {
        // const newCount = this.getItemCount() // ใช้ items count ที่มีใน local
        const newCount = items.length // ใช้ items count ที่มีใน local
        await this.setCount(isSearchMode, newCount)
        // this._updateCountToParent(newCount)
      }

      if (fetchedData.items) {
        await this.loadProductListItems(fetchedData.items, fetchOffset, isSearchMode)
      } else {
        // เพื่อให้ reducer คำนวณการ cut off product items
        await this.loadProductListItems([], fetchOffset, isSearchMode)
      }

      // await this.setIsLoadingByOffset(isSearchMode, false, fetchOffset)
    } catch (err) {
      // await this.setIsLoadingByOffset(isSearchMode, false, fetchOffset)
    }
  }

  _handleRefresh = async () => {
    // console.log('_handleRefresh this.isRefreshing => ', this.isRefreshing)
    if (this.isRefreshing) {
      return
    }
    this.isRefreshing = true

    const { isRefreshing } = this.state
    // console.log('_handleRefresh isRefreshing => ', isRefreshing)
    if (isRefreshing) {
      this.isRefreshing = false
      return
    }
    // this.props.context.resetState()
    await util.setStatePromise(this, { isRefreshing: true })
    await util.delay(100)

    const isSearchMode = this.isSearchMode()
    await this._fetchItems({ offset: 0, isSearchMode })

    await util.setStatePromise(this, { isRefreshing: false })
    await util.delay(100)
    this.isRefreshing = false
  }

  _handleLoadMore = async () => {
    const { hasLoadMore } = this.state
    if (!hasLoadMore) {
      return
    }

    if (this.isFetching) {
      return
    }
    this.isFetching = true

    await util.setStatePromise(this, { isFetching: true })

    const isSearchMode = this.isSearchMode()
    await this._fetchItems({ isLoadMore: true, isSearchMode })

    await util.setStatePromise(this, { isFetching: false })

    this.isFetching = false
  }

  goBack = () => {
    const { navigation } = this.props
    if (!navigation) {
      return
    }
    util.navGoBack(this.props)
  }

  navToProductViewModeAdd = () => {
    const { navigation } = this.props
    const storeId = util.getNavParam(this.props, 'store_id')
    navigation.dispatch(
      NavActions.navToProductViewAddProduct({
        store_id: storeId,
        onSuccessAddProductCallback: this.onSuccessAddProductCallback,
        onSuccessEditProductCallback: this.onSuccessEditProductCallback,
      })
    )
  }

  prepentProductListItem = async (productListItem: ProductListItemType) => {
    const { mainProductListItems, searchProductListItems } = this.state
    const isSearchMode = this.isSearchMode()
    const newProductListItems = isSearchMode ? [productListItem, ...searchProductListItems] : [productListItem, ...mainProductListItems]

    if (isSearchMode) {
      await util.setStatePromise(this, { searchProductListItems: newProductListItems })
    } else {
      await util.setStatePromise(this, { mainProductListItems: newProductListItems })
    }
  }

  // ทำการ prepend product item ใน list
  onSuccessAddProductCallback = async (addedProduct: IProductDetailItem) => {
    // const mainListRef = this.getMainProductListRef()
    // const productListItem = this.getProductListItemFromProductDetailItem(addedProduct)
    // // @ts-ignore FIXME: พังจากการพยายาม generic ProductListItemType
    // await mainListRef.prependItem(productListItem)

    await this.prepentProductListItem(this.getProductListItemFromProductDetailItem(addedProduct))
  }

  getProductListItemFromProductDetailItem = (pdi: IProductDetailItem): IProductItemData => {
    // // Compute all available qty of variants
    // const availableQty = pdi.variants.reduce((prevAq, vItem) => {
    //   const aq = vItem.available_qty
    //   if (!aq) {
    //     return prevAq
    //   }
    //   return prevAq + aq
    // }, 0)

    // // Construct ProductListItem
    // const item: IProductItemData = {
    //   id: pdi.id,
    //   n: pdi.name,
    //   t: pdi.thumbnail_uris,
    //   i: pdi.min,
    //   x: pdi.max,
    //   q: availableQty,
    // }

    // // is my product?
    // if (pdi.parent_id) {
    //   item.h = pdi.parent_id
    //   item.m = 1
    // }

    // return item
    const pdli = util.convertFullProductDetailToShortProductListItem(pdi)
    return pdli
  }

  updateProductListItem = async (productListItem: ProductListItemType) => {
    const { mainProductListItems, searchProductListItems } = this.state
    const newState: Partial<IState> = {}
    const newMainProductListItems = [...mainProductListItems]
    const newSearchProductListItems = [...searchProductListItems]

    const mainIndex = newMainProductListItems.findIndex((item) => item.id === productListItem.id)
    if (mainIndex >= 0) {
      newMainProductListItems[mainIndex] = productListItem
      newState.mainProductListItems = newMainProductListItems
    }

    const searchIndex = newSearchProductListItems.findIndex((item) => item.id === productListItem.id)
    if (searchIndex >= 0) {
      newSearchProductListItems[searchIndex] = productListItem
      newState.searchProductListItems = newSearchProductListItems
    }

    if (!_.isEmpty(newState)) {
      await util.setStatePromise(this, newState)
    }
  }

  // ทำการ modify product item ใน list
  onSuccessEditProductCallback = async (editedProduct: IProductDetailItem) => {
    // console.log('TOBE:Implement editedProduct => ', editedProduct)
    const productListItem = this.getProductListItemFromProductDetailItem(editedProduct)
    // const searchListRef = this.getSearchProductListRef()
    // // @ts-ignore FIXME: พังจากการพยายาม generic ProductListItemType
    // await searchListRef.repalceItemByKey('id', editedProduct.id, productListItem)
    // const mainListRef = this.getMainProductListRef()
    // // @ts-ignore FIXME: พังจากการพยายาม generic ProductListItemType
    // await mainListRef.repalceItemByKey('id', editedProduct.id, productListItem)

    await this.updateProductListItem(productListItem)
  }

  deleteProductListItem = async (deletedProductId: number) => {
    const { mainProductListItems, searchProductListItems } = this.state
    const newMainProductListItems = [...mainProductListItems]
    const newSearchProductListItems = [...searchProductListItems]
    const newState: Partial<IState> = {}

    const mainIndex = newMainProductListItems.findIndex((item) => item.id === deletedProductId)
    if (mainIndex >= 0) {
      newMainProductListItems.splice(mainIndex, 1)
      newState.mainProductListItems = newMainProductListItems
    }

    const searchIndex = newSearchProductListItems.findIndex((item) => item.id === deletedProductId)
    if (searchIndex >= 0) {
      newSearchProductListItems.splice(searchIndex, 1)
      newState.searchProductListItems = newSearchProductListItems
    }

    if (!_.isEmpty(newState)) {
      await util.setStatePromise(this, newState)
    }
  }

  // ทำการ remove product item ใน list
  onSuccessDeleteProductCallback = async (deletedProductId: number) => {
    // const searchListRef = this.getSearchProductListRef()
    // await searchListRef.removeItemByKey('id', deletedProductId)
    // const mainListRef = this.getMainProductListRef()
    // await mainListRef.removeItemByKey('id', deletedProductId)

    await this.deleteProductListItem(deletedProductId)
  }

  // openBarcodeCamera = () => this.setState({ isBarcodeCameraVisible: true })
  // closeBarcodeCamera = async () => this.setState({ isBarcodeCameraVisible: false })

  // // override me please
  // onPressProductItem = (item: { index?: number; data: ProductListItemType }) => {
  //   // this.navToProductViewModeView(item.data.id)
  // }

  // onPressProductCategoryFilter = () => {
  //   try {
  //     this.drawerCatRef.current.open()
  //   } catch (error) {
  //     util.log(error)
  //   }
  // }

  _checkSearchTextOnFilter = async () => {
    const { filterState, searchText } = this.state

    const filterSearchText = filterState && filterState.searchText ? filterState.searchText : null
    if (_.isString(searchText) && (_.isNil(filterSearchText) || filterSearchText !== searchText)) {
      const newFilter = _.cloneDeep(filterState)
      newFilter.searchText = searchText
      await util.setStatePromise(this, { filterState: newFilter })
    }
  }

  // สั่งให้ InfiniteFlatList reset state ใหม่ทั้งหมด
  doRefresh = async () => {
    this.returnCategoryInfo = true
    const newState: Partial<IProductListViewState> = {}

    await this._checkSearchTextOnFilter()

    if (this.isSearching()) {
      await util.setStatePromise(this, { searchFetchErrorMessage: null })
      newState.searchProductCount = null
    } else {
      await util.setStatePromise(this, { mainFetchErrorMessage: null })
      newState.mainProductCount = null
    }
    // @ts-ignore FIXME: @O type ไม่ถูกต้อง
    await util.setStatePromise(this, newState)
    await util.delay(200)
    // const productListRef = this.getFocusProductListRef()
    // if (productListRef && _.isFunction(productListRef.reset)) {
    //   await productListRef.reset()
    // }

    await this._handleRefresh()
  }

  // Internal Method
  _onPressProductItem = async (item: { index?: number; data: ProductListItemType }) => {
    if (this.inNavigationProcess) {
      return
    }
    this.inNavigationProcess = true
    await util.delay(200)
    if (_.isFunction(this.onPressProductItem)) {
      await this.onPressProductItem(item)
    }
    await util.delay(200)
    this.inNavigationProcess = false
  }

  _onChangeMainProductCount = (newCount: number) => this.setState({ mainProductCount: newCount })

  _onChangeProductListNumOfColumns = (newCount: number) => this.setState({ mainProductNumOfColumns: newCount })

  _onChangeSearchProductCount = (newCount: number) => this.setState({ searchProductCount: newCount })

  _applyRoleIdToRequestBody = (body) => {
    const newBody = _.cloneDeep(body)
    // backend require if role_id === 2 (helper)
    const selectedStoreId = this.props.selectedStore.get('id')
    const roleId = this.props.selectedStore.get('role_id') || null
    if (body.store_id === selectedStoreId && roleId === 2) {
      // ถ้าเป็นการ fetch สินค้าของร้านฉันให้ส่ง role_id ของ selectedStore ของฉันไป
      newBody.role_id = roleId
    }
    return newBody
  }

  // ใช้สั่ง reset searchList เพื่อทำให้เกิดการค้นหาใหม่
  refreshSearchList = async () => {
    if (!this.isSearching()) {
      return
    }
    const now = moment()
    const diffLastTypingMs = Math.abs(now.diff(this.lastSearchTypingDateTime, 'milliseconds'))
    if (diffLastTypingMs < SEARCH_TYPING_DELAY) {
      return
    }

    // current searchText
    const { searchText } = this.state
    if (this.lastSearchSuccessDateTime) {
      const diffLastSuccessMs = Math.abs(now.diff(this.lastSearchSuccessDateTime, 'milliseconds'))
      if (this.lastSearchText === searchText && diffLastSuccessMs < SEARCH_LATEST_KEYWORD_TIMEOUT) {
        // ถ้ามีการ search text เดียวกันภายใน 5 วินาทีที่ผ่านมาให้ ignore ไปก่อน (เผื่อ user กด submit ใหม่)
        return
      }
    }
    this.lastSearchText = searchText
    await this.doRefresh()
    this.lastSearchSuccessDateTime = moment()
  }

  _handleClearSearch = async () => {
    if (this.isInitFetching) {
      return
    }
    this.isInitFetching = true

    const defaultFilter = this.getDefautProductListFilterState()
    await util.setStatePromise(this, { searchText: '', isBarcodeSearching: false, filterState: defaultFilter })
    await util.delay(100)
    await this.doRefresh()

    this.isInitFetching = false
  }

  _handleChangeSearchText = (newText: string) => {
    const newState: Partial<IProductListViewState> = {
      searchText: newText,
      searchProductListItems: [],
      searchFetchErrorMessage: null,
      searchProductCount: null,
    }

    if (newText === '') {
      newState.isBarcodeSearching = false
      newState.hasLoadMore = true
      newState.isRefreshing = false
    }

    if (newText.length < MINIMUM_SEARCH_TEXT_LENGTH) {
      newState.searchProductListItems = []
      newState.searchProductCount = null
      newState.isRefreshing = false
    }

    // await util.setStatePromise<any>(this, newState)
    // await util.delay(200)
    // this._enqueueSearch()

    // @ts-ignore
    this.setState(newState, () => {
      // setTimeout(this._enqueueSearch, 600 + 50 * newText.length)
      // setTimeout(this._enqueueSearch, 1500)
      this._enqueueSearch()
    })
  }

  _enqueueSearch = () => {
    if (this.lastSearchTimeout) {
      clearTimeout(this.lastSearchTimeout)
    }

    if (!this.isSearching()) {
      return
    }

    // if (this.lastSearchRefreshQueueTimeout) {
    //   clearTimeout(this.lastSearchRefreshQueueTimeout)
    // }
    // this.lastSearchTypingDateTime = moment()
    // // @ts-ignore
    // // this.lastSearchRefreshQueueTimeout = setTimeout(this.refreshSearchList, SEARCH_TYPING_DELAY)
    // this.lastSearchRefreshQueueTimeout = setTimeout(this._handleSearch, SEARCH_TYPING_DELAY)

    this.lastSearchTimeout = setTimeout(this._handleSearch, 1500)
  }

  _handleSearch = () => {
    const { searchText } = this.state
    if (!searchText || searchText.length < MINIMUM_SEARCH_TEXT_LENGTH) {
      return
    }
    // await util.setStatePromise(this, { searchProductListItems: [], searchFetchErrorMessage: null, searchProductCount: null })
    this._handleRefresh()
  }

  _handleSubmitSearchByKeyboard = async () => {
    const { searchText } = this.state
    if (!searchText || searchText.length < MINIMUM_SEARCH_TEXT_LENGTH) {
      return
    }

    this._enqueueSearch()
  }

  _onProductCatScrollViewLayout = (evt) => {
    try {
      const { width } = evt.nativeEvent.layout
      const editedProperties = _.cloneDeep(this.state.productCategoryScrollViewProperties)
      editedProperties.currentWidth = width
      this.setState({ productCategoryScrollViewProperties: editedProperties })
    } catch (err) {
      // console.error('_onLayout err => ', err)
    }
  }

  _onProductCategoryScrollContentSizeChange = (width: number, height: number) => {
    const { currentWidth } = this.state.productCategoryScrollViewProperties
    const w = width - currentWidth
    this.productCategoryScrollableMaxX = w > 0 ? w : 0
    this.setState({
      productCategoryScrollViewProperties: {
        currentWidth,
        isVisibleScrollToBeginButton: this.productCategoryScrollableMaxX > 0 && this.productCategoryLastScrollX > 0,
        isVisibleScrollToEndButton:
          this.productCategoryScrollableMaxX > 0 && this.productCategoryLastScrollX < this.productCategoryScrollableMaxX - 4,
      },
    })
  }

  _handleProductCategoryScroll = (e) => {
    const { currentWidth } = this.state.productCategoryScrollViewProperties
    this.productCategoryLastScrollX = e.nativeEvent.contentOffset.x
    this.setState({
      productCategoryScrollViewProperties: {
        currentWidth,
        isVisibleScrollToBeginButton: this.productCategoryScrollableMaxX > 0 && this.productCategoryLastScrollX > 0,
        isVisibleScrollToEndButton:
          this.productCategoryScrollableMaxX > 0 && this.productCategoryLastScrollX < this.productCategoryScrollableMaxX - 8,
      },
    })
  }

  _handleProductCategoryScrollToBegin = () => {
    try {
      const { currentWidth } = this.state.productCategoryScrollViewProperties
      let nextOffset = this.productCategoryLastScrollX - currentWidth + 60
      if (nextOffset < 0) {
        nextOffset = 0
      }
      this.productCategoryScrollRef.current.scrollTo({ x: nextOffset, animated: true })
    } catch (err) {
      util.log(err)
    }
  }

  _handleProductCategoryScrollToEnd = () => {
    try {
      const { currentWidth } = this.state.productCategoryScrollViewProperties
      let nextOffset = this.productCategoryLastScrollX + currentWidth - 60
      if (nextOffset > this.productCategoryScrollableMaxX) {
        nextOffset = this.productCategoryScrollableMaxX
      }
      this.productCategoryScrollRef.current.scrollTo({ x: nextOffset, animated: true })
    } catch (err) {
      util.log(err)
    }
  }

  // _setCallBackMKPChannels = async (mkp_ch_ids: number[]) => {
  //   if (!_.isNil(mkp_ch_ids)) {
  //     await util.setStatePromise(this, {
  //       mkp_ch_ids,
  //     })
  //   } else {
  //     await util.setStatePromise(this, {
  //       mkp_ch_ids: [],
  //     })
  //   }
  // }

  _onSubmitProductListFilter = async (filterState: IProductListFilterState | IProductListFilterTemplate) => {
    // _onSubmitProductListFilter = async (submit: ISubmitDrawerCategory) => {
    // const { category, allChildrenCategory = true } = filterState
    // console.log('_onSubmitProductListFilter filterState => ', filterState)
    const hasSearchText = filterState && 'searchText' in filterState
    await util.setStatePromise(this, { filterState, searchText: hasSearchText ? filterState.searchText : '' })
    await util.delay(50)

    // // await this._setCallBackMKPChannels(submit.mkp_ch_ids)
    // // await this._setallChildrenCategory(allChildrenCategory)
    // await util.setStatePromise(this, { allChildrenCategory })

    // // if (!_.isNil(category)) {
    // await this._selectedSubCategory(category)
    // // }

    this.doRefresh()
  }

  // _setallChildrenCategory = async (value: boolean) => {
  //   await util.setStatePromise(this, { allChildrenCategory: value })
  // }

  // _selectedSubCategory = async (category: ICategory) => {
  //   if (_.isNil(category)) {
  //     await this._configCategory()
  //     // await this.doRefresh()
  //     return
  //   }

  //   const { categoryList, selectedStore, navigation } = this.props
  //   // const store_id = selectedStore.get('id')
  //   const { store_id, seller_store_id, mode } = this._getParams()
  //   let storeId = this.getTargetStoreId()
  //   if (mode === PULL_PRODUCT) {
  //     storeId = seller_store_id
  //   } else if (mode === PULL_SELLER_PRODUCT_TO_ORDER) {
  //     storeId = seller_store_id
  //   } else if (mode === VIEW_SELLER) {
  //     storeId = seller_store_id
  //   }

  //   let CATEGORYS = null
  //   const CettoJS = _.isNil(categoryList) ? [] : categoryList.toJS()
  //   CettoJS.map((data: categoryByStore) => {
  //     if (storeId === data.store_id) {
  //       CATEGORYS = data.category
  //       if (category.id === 0) {
  //         CATEGORYS.push(category)
  //       } else {
  //         const unknownCat: ICategory = { id: 0, n: `ไม่ระบุหมวดหมู่`, l: COLORS.TEXT_INACTIVE }
  //         CATEGORYS.push(unknownCat)
  //       }
  //     }
  //   })
  //   if (!_.isNil(CATEGORYS) && _.isArray(CATEGORYS)) {
  //     const newLvlCat: ICategory[] = []
  //     const newSubCat: ICategory[] = []
  //     CATEGORYS.map((xData: ICategory) => {
  //       const data = xData
  //       if (xData.id === category.id) {
  //         data.selected = true
  //       }

  //       if (!_.isNil(data.p) && data.p === category.id) {
  //         newSubCat.push(data)
  //       }
  //       if (_.isNil(category.p) && _.isNil(data.p)) {
  //         newLvlCat.push(data)
  //       } else if (data.p === category.p) {
  //         newLvlCat.push(data)
  //       }
  //     })
  //     // if (_.isNil(category.p)) {
  //     //   const unknownCat: ICategory = { id: 0, n: `ไม่ระบุหมวดหมู่`, l: COLORS.TEXT_INACTIVE }
  //     //   newLvlCat.push(unknownCat)
  //     // }

  //     const { filterState: fs = {} } = this.state
  //     const filterState: IProductListFilterState = { ...fs }
  //     if (category) {
  //       filterState.category = category
  //     }
  //     await util.setStatePromise(this, {
  //       catLevelCategoryList: newLvlCat,
  //       catSeletedCategory: category,
  //       catSupCategory: newSubCat,
  //       filterState,
  //     })
  //     // await this.doRefresh()
  //   }
  // }

  // _onPressProductCategory = async (category: ICategory) => {
  //   await this._selectedSubCategory(category)
  //   await this.doRefresh()
  // }

  _getParams() {
    // _getParams(): { store_id: number; mode: string; seller_store_id: number } {
    // return this.props.navigation.state.params
    const params = util.getNavParams(this.props)
    return params
  }

  _configCategory = async () => {
    const { categoryList, requestCategoryList, navigation } = this.props
    const { mode, store_id, seller_store_id } = this._getParams()
    // console.log('mode => ', mode)
    if (mode === MKP_MAPPING) {
      return null
    }
    // const { mode, store_id, seller_store_id } = this._getParams()
    let storeId = this.getTargetStoreId()
    // const storeId = this.getTargetStoreId()
    let CATEGORYS = null
    const CettoJS = _.isNil(categoryList) ? [] : categoryList.toJS()
    CettoJS.map((data: categoryByStore) => {
      if (storeId === data.store_id) {
        CATEGORYS = data.category
      }
    })

    if (mode === PULL_PRODUCT) {
      storeId = seller_store_id
    } else if (mode === PULL_SELLER_PRODUCT_TO_ORDER) {
      storeId = seller_store_id
    } else if (mode === VIEW_SELLER) {
      storeId = seller_store_id
    }
    if (_.isNil(CATEGORYS) || CATEGORYS.length < 1) {
      const res: ICategory[] = await new Promise((resolve) => {
        requestCategoryList({
          body: {
            store_id: storeId,
          },
          successCallback: resolve,
          failedCallback: resolve,
        })
      })
      if (!_.isNil(res) && _.isArray(res)) {
        CATEGORYS = res
      }
    }
    const catSeletedCategory = null
    const catLevelCategoryList = []
    const catSupCategory = []
    if (_.isNil(CATEGORYS)) {
      CATEGORYS = []
    }
    const haveUnknownCat = CATEGORYS.find((data: ICategory) => data.id === 0)
    if (_.isNil(haveUnknownCat)) {
      const unknownCat: ICategory = { id: 0, n: `ไม่ระบุหมวดหมู่`, l: COLORS.TEXT_INACTIVE }
      CATEGORYS.push(unknownCat)
    }
    CATEGORYS.map((data: ICategory) => {
      if (_.isNil(data.p)) {
        catSupCategory.push(data)
        catLevelCategoryList.push(data)
      }
    })

    await util.setStatePromise(this, {
      catSeletedCategory,
      catLevelCategoryList,
      catSupCategory,
    })
  }

  onToggleCheckProductListItem = async (item: ProductListItemType) => {
    const { checkedProductListItem = {} } = this.state
    const newCheckedProductListItem = _.cloneDeep(checkedProductListItem)
    if (newCheckedProductListItem[item.id]) {
      // ถ้าเคย check ไว้แล้ว ให้ uncheck
      delete newCheckedProductListItem[item.id]
    } else {
      // ถ้าไม่เคย check ไว้ ให้ check
      newCheckedProductListItem[item.id] = true
    }
    // console.log('onToggleCheckProductListItem newCheckedProductListItem => ', newCheckedProductListItem)
    await util.setStatePromise(this, { checkedProductListItem: newCheckedProductListItem })
  }

  isCheckedProductListItem = (item: ProductListItemType) => {
    const { checkedProductListItem = {} } = this.state
    return checkedProductListItem[item.id]
  }

  // Render Methods
  // renderProductListItem = (pItem: { item?: ProductListItemType; index: number; itemWidth: number }) => (
  renderProductListItem = (pItem: ListRenderItemInfo<ProductListItemType>) => {
    const listViewMode = this.getProductListViewMode()
    const { item, index } = pItem

    const isChecked = this.isCheckedProductListItem(item)
    return (
      <ProductListItem
        // key={`PLI_${item.index}_${item.id}_${isChecked}`}
        // @ts-ignore FIXME: พังจากการพยายาม generic ProductListItemType
        // key={`PLI_${pItem.index}_${pItem.item.id}`}
        // @ts-ignore FIXME: พังจากการพยายาม generic ProductListItemType
        data={item}
        index={index}
        // maxWidth={pItem.itemWidth}
        maxWidth={this.listItemWidth}
        disabled={this.isProductListItemPressDisabled()}
        // @ts-ignore FIXME: พังจากการพยายาม generic ProductListItemType
        onPress={_.isFunction(this.onPressProductItem) ? this._onPressProductItem : undefined}
        // @ts-ignore FIXME: พังจากการพยายาม generic ProductListItemType
        renderBottom={this.renderProductListItemBottom}
        numOfColumns={this.state.mainProductNumOfColumns}
        disabledIsSellerProductIcon={this.isProductListItemSellerIconDisabled()}
        disabledPrice={this.isProductListItemPriceDisabled()}
        disabledQty={this.isProductListItemQtyDisabled()}
        // @ts-ignore FIXME: พังจากการพยายาม generic ProductListItemType
        renderIcon={this.renderProductListItemIcon}
        listViewMode={listViewMode}
        isChecked={isChecked}
        onToggleCheck={this.onToggleCheckProductListItem}
      />
    )
  }

  // Override here if need ProductListItem special Info/Button
  renderProductListItemBottom = (item: { index: number; data: ProductListItemType }) => null

  // Override here if need ProductListItem special Info/Button
  renderProductListItemIcon = (item: { index: number; data: ProductListItemType }) => null

  // _renderProductCategoryScrollToBeginButton = () => {
  //   if (!this.state.productCategoryScrollViewProperties.isVisibleScrollToBeginButton) {
  //     return null
  //   }

  //   return (
  //     <TouchableOpacity
  //       // onPress={() => this.productCategoryScrollRef.current.scrollTo({ x: 0, animated: true })}
  //       onPress={this._handleProductCategoryScrollToBegin}
  //       style={{
  //         flex: 1,
  //         position: 'absolute',
  //         left: 0,
  //         height: 35,
  //         width: 22,
  //         flexDirection: 'row',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         backgroundColor: 'rgba(88,88,88,0.4)',
  //       }}>
  //       <XIcon name='arrow-back' />
  //     </TouchableOpacity>
  //   )
  // }

  // _renderProductCategoryScrollToEndButton = () => {
  //   if (!this.state.productCategoryScrollViewProperties.isVisibleScrollToEndButton) {
  //     return null
  //   }

  //   return (
  //     <TouchableOpacity
  //       // onPress={() => this.productCategoryScrollRef.current.scrollToEnd()}
  //       onPress={this._handleProductCategoryScrollToEnd}
  //       style={{
  //         flex: 1,
  //         position: 'absolute',
  //         right: 0,
  //         height: 35,
  //         width: 22,
  //         flexDirection: 'row',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         backgroundColor: 'rgba(88,88,88,0.4)',
  //       }}>
  //       <XIcon name='arrow-forward' />
  //     </TouchableOpacity>
  //   )
  // }

  // _renderCatListItems = (categories) =>
  //   categories.map((data: ICategory, index: number) => {
  //     const marginLeft = index === 0 ? 12 : 12
  //     const marginRight = index + 1 === categories.length ? 4 : 4
  //     const textColor = data.l ? data.l : COLORS.TEXT_INACTIVE
  //     return (
  //       <TouchableOpacity
  //         key={`CatListItem_${index}_${data.id}`}
  //         // onPress={() => this._selectedSubCategory(data)}
  //         onPress={() => this._onPressProductCategory(data)}
  //         style={{
  //           // minWidth: 50,
  //           // // width: 50,
  //           // // maxWidth: 120,
  //           // // height: 25,
  //           // borderColor: data.l,
  //           // borderWidth: 0.7,
  //           // borderRadius: 7,
  //           marginLeft,
  //           marginRight,
  //           // paddingLeft: 4,
  //           // paddingRight: 4,
  //           // justifyContent: 'center',
  //         }}>
  //         <Box minW='50px' borderWidth='1' borderRadius='lg' px='2' py='1' alignItems='center' justifyContent='center' borderColor={data.l}>
  //           <XText style={{ color: textColor }}>{data.n}</XText>
  //         </Box>
  //       </TouchableOpacity>
  //     )
  //   })

  _onSelectCategory = (category: ICategory) => {
    const { filterState = {} } = this.state

    const newFilterState = { ...filterState } as IProductListFilterState
    if (_.isObject(category) && 'id' in category) {
      newFilterState.selectedCategoryId = category.id
    } else {
      newFilterState.selectedCategoryId = null
    }

    if ('id' in newFilterState) {
      delete newFilterState.id
    }

    this._onSubmitProductListFilter(newFilterState)
  }

  renderCatListBar = () => {
    const { filterState = {}, isInitialized } = this.state

    if (!isInitialized) {
      return null
    }

    const storeId = this.getTargetStoreId()

    return (
      <ProductCategorySelector
        key={storeId}
        storeId={storeId}
        // @ts-ignore
        selectedCategoryId={_.isObject(filterState) && _.isNumber(filterState.selectedCategoryId) ? filterState.selectedCategoryId : null}
        onSelectCategory={this._onSelectCategory}
      />
    )

    // // const { categoryList } = this.props
    // const { catSupCategory, mainProductCount } = this.state
    // if (_.isNil(mainProductCount)) {
    //   return null
    // }

    // const categories = _.isNil(catSupCategory) ? [] : catSupCategory
    // // const bodyHeight = categories.length < 1 ? 0 : 35

    // const isHidden = !categories || categories.length === 0
    // if (isHidden) {
    //   return null
    // }

    // return (
    //   <XHorizontalScrollView w='full' _contentContainerStyle={{ py: '2' }} bg={COLORS.BG_SOFT_GREY}>
    //     {this._renderCatListItems(categories)}
    //   </XHorizontalScrollView>
    // )
    // // return (
    // //   <View
    // //     style={[
    // //       S.WIDTH_FULL,
    // //       S.MIN_HEIGHT_40,
    // //       S.ROW_MIDDLE_START,
    // //       {
    // //         backgroundColor: COLORS.BG_SOFT_GREY,
    // //       },
    // //     ]}>
    // //     <ScrollView
    // //       ref={this.productCategoryScrollRef}
    // //       onLayout={this._onProductCatScrollViewLayout}
    // //       onContentSizeChange={this._onProductCategoryScrollContentSizeChange}
    // //       // style={{ maxWidth: this.getScreenWidth() }}
    // //       style={[S.WIDTH_FULL, S.MIN_HEIGHT_34]}
    // //       contentContainerStyle={[S.ROW_MIDDLE_START]}
    // //       horizontal
    // //       // showsHorizontalScrollIndicator={p.op.isWeb()}
    // //       showsHorizontalScrollIndicator={false}
    // //       onScroll={p.op.isWeb() ? this._handleProductCategoryScroll : null}
    // //       onMomentumScrollEnd={this._handleProductCategoryScroll}
    // //       onScrollEndDrag={this._handleProductCategoryScroll}>
    // //       {this._renderCatListItems(categories)}
    // //     </ScrollView>
    // //     {p.op.isWeb() ? this._renderProductCategoryScrollToBeginButton() : null}
    // //     {p.op.isWeb() ? this._renderProductCategoryScrollToEndButton() : null}
    // //   </View>
    // // )
  }

  // _renderCategoryFilterView = () => {
  //   const { categoryList } = this.props
  //   const { catLevelCategoryList } = this.state
  //   return (
  //     <CategoryFilterView
  //       onRequestCloseView={this.onRequestCloseCategoryFilterView}
  //       levelCategoryList={catLevelCategoryList}
  //       categoryList={categoryList.toJS()}
  //       // selectedCategory={catSeletedCategory}
  //       // submit={async (category: ISubmitDrawerCategory) => this._onSubmitProductListFilter(category)}
  //       onSubmit={this._onSubmitProductListFilter}
  //     />
  //   )
  // }

  getProductListViewMode = () => {
    const { listViewMode = 'grid' } = this.state
    return listViewMode
  }

  toggleListViewMode = () => {
    const { listViewMode = 'grid' } = this.state
    const newMode = listViewMode === 'list' ? 'grid' : 'list'
    this.setState({ listViewMode: newMode }, () => {
      p.op.storageSet('ProductListView_listViewMode', newMode, false)
    })
  }

  renderListViewModeButton = () => {
    // if (!util.isDevMode()) {
    //   return null
    // }

    if (!this.isChangeRenderModeButtonVisible() || this.isSearchMode()) {
      return null
    }
    const listViewMode = this.getProductListViewMode()
    const isDisabled = !this.isProductListViewReady()
    return (
      <XIconButton
        family='MaterialIcons'
        name={listViewMode === 'list' ? 'grid-view' : 'view-list'}
        disabled={isDisabled}
        onPress={this.toggleListViewMode}
      />
    )
  }

  renderAddProductButton = () => {
    if (!this.isAddProductButtonVisible() || this.isSearchMode()) {
      return null
    }
    const isAddProductAvailable = acl.canDoAtSelectedStore(CONS.PERM_STORE_HELPER.PRODUCT_ADD)
    if (!isAddProductAvailable) {
      return null
    }

    const isDisabled = !this.isProductListViewReady()
    return <XIconButton family='AntDesign' name='plus' disabled={isDisabled} onPress={this.navToProductViewModeAdd} />
  }

  isFiltered = () => {
    const { filterState = {} } = this.state
    const defaultFilter = this.getDefautProductListFilterState()

    const filterDiff = diff(defaultFilter, filterState)

    if ('searchText' in filterDiff) {
      delete filterDiff.searchText
    }

    if (_.isEmpty(filterDiff)) {
      return false
    }
    return true
  }

  renderFilterProductsButton = () => {
    // const { catSeletedCategory } = this.state
    // const selected = !_.isNil(catSeletedCategory)
    // const isDisabled = !this.isProductListViewReady()
    // return (
    //   <TouchableOpacity disabled={isDisabled} onPress={this.onPressProductCategoryFilter}>
    //     <VStack w='9' h='9' alignItems='center' justifyContent='center'>
    //       <Box pt='1'>
    //         <XIcon family='MaterialCommunityIcons' name='filter' variant={isDisabled ? 'inactive' : 'primary'} />
    //         {selected ? (
    //           <XIcon
    //             family='MaterialCommunityIcons'
    //             name='check-circle'
    //             variant='success'
    //             position='absolute'
    //             bottom='0'
    //             right='0'
    //             size='12px'
    //             // style={{ fontSize: 12, width: 12, height: 12, color: COLORS.BRAND_Success }}
    //             // style={{ color: COLORS.BRAND_Success, fontSize: 12, position: 'absolute', paddingTop: 12, paddingLeft: 12 }}
    //           />
    //         ) : null}
    //       </Box>
    //     </VStack>
    //   </TouchableOpacity>
    // )
    // const { categoryList } = this.props
    // const { catLevelCategoryList, filterState = {} } = this.state

    // return (
    //   <ProductListFilterView
    //     // ref={this.drawerCatRef}
    //     levelCategoryList={catLevelCategoryList}
    //     categoryList={categoryList.toJS()}
    //     // selectedCategory={catSeletedCategory}
    //     // submit={async (category: ISubmitDrawerCategory) => this._onSubmitProductListFilter(category)}
    //     defaultFilter={this.getDefautProductListFilterState()}
    //     currentFilter={filterState}
    //     onSubmit={this._onSubmitProductListFilter}
    //   />
    // )

    const isFiltered = this.isFiltered()
    const isDisabled = !this.isProductListViewReady()

    return (
      <TouchableOpacity disabled={isDisabled} onPress={this.onPressProductCategoryFilter}>
        <VStack w='9' h='9' alignItems='center' justifyContent='center'>
          <Box pt='1'>
            <XIcon family='MaterialCommunityIcons' name='filter' variant={isDisabled ? 'inactive' : 'primary'} />
            {isFiltered ? (
              <XIcon
                family='MaterialCommunityIcons'
                name='check-circle'
                variant='success'
                position='absolute'
                bottom='0'
                right='0'
                size='12px'
                // style={{ fontSize: 12, width: 12, height: 12, color: COLORS.BRAND_Success }}
                // style={{ color: COLORS.BRAND_Success, fontSize: 12, position: 'absolute', paddingTop: 12, paddingLeft: 12 }}
              />
            ) : null}
          </Box>
        </VStack>
      </TouchableOpacity>
    )
  }

  onPressProductCategoryFilter = () => {
    // const { categoryList } = this.props
    // const { catLevelCategoryList, filterState = {} } = this.state
    const { filterState = {} } = this.state

    const { navigation } = this.props
    navigation.dispatch(
      NavActions.navToProductListFilterView({
        store_id: this.getTargetStoreId(),
        // levelCategoryList: catLevelCategoryList,
        // categoryList: categoryList.toJS(),
        defaultSetting: this.getDefautProductListFilterState(),
        // currentFilter: filterState,
        appliedSetting: filterState,
        onSubmit: this._onSubmitProductListFilter,
      })
    )
  }

  getSearchTextWithCountPlaceholder = (mainProductCount: number) => `ค้นหาสินค้าในร้าน ${mainProductCount}`

  getSearchTextWithoutCountPlaceholder = () => 'ไม่พบรายการสินค้า'

  getSearchTextPlaceholder = () => {
    if (!this.isProductListViewReady()) {
      return 'กำลังโหลดข้อมูล...'
    }

    // เช็คเฉพาะ mainProductCount เนื่องจาก เมื่อเราพิมพ์ลงใน search box ก็จะไม่เห็น placeholder อยู่ดี
    const { searchText = '', catSeletedCategory, mainProductCount } = this.state
    if (searchText.length > 0) {
      return ''
    }

    const hasProducts = mainProductCount > 0
    let placeholderSearch = hasProducts
      ? this.getSearchTextWithCountPlaceholder(mainProductCount)
      : this.getSearchTextWithoutCountPlaceholder()
    // if (mode === PULL_PRODUCT) {
    //   placeholderSearch = canSearch ? `ค้นหาสินค้าพร้อมดึง ${textCount}` : ''
    // }
    if (_.isObject(catSeletedCategory) && _.isString(catSeletedCategory.n)) {
      placeholderSearch = catSeletedCategory.n
      if (_.isNumber(mainProductCount) && mainProductCount > 0) {
        placeholderSearch += ` มี ${mainProductCount} รายการสินค้า`
      } else {
        placeholderSearch += ` ไม่พบรายการสินค้า`
      }
    }
    return placeholderSearch
  }

  renderSearchInfoBar = () => {
    if (!this.isSearchMode()) {
      return null
    }
    const { searchText = '', searchProductCount, catSeletedCategory, isRefreshing } = this.state

    let txtSearchResult
    if (isRefreshing) {
      txtSearchResult = `กำลังค้นหาสินค้าที่มีชื่อประกอบด้วย "${searchText}" ...`
    } else if (!this.isSearching()) {
      // txtSearchResult = `กำลังค้นหาสินค้าที่มีชื่อประกอบด้วย "${searchText}" ...`
      txtSearchResult = `กรุณาพิมพ์ ${MINIMUM_SEARCH_TEXT_LENGTH} ตัวอักษรขึ้นไป`
    } else {
      if (searchProductCount) {
        txtSearchResult = `${searchProductCount} รายการตรงกับการค้นหา "${searchText}"`
      } else {
        txtSearchResult = `ไม่พบสินค้าที่มีชื่อประกอบด้วย "${searchText}"`
      }
      if (catSeletedCategory && catSeletedCategory.n) {
        txtSearchResult += `ในหมวดหมู่ "${catSeletedCategory.n}"`
      }
    }

    return (
      <HStack w='full' p='2' alignItems='center'>
        <XText fontSize='xs' variant='inactive' numberOfLines={2}>
          {txtSearchResult}
        </XText>
      </HStack>
    )
  }

  renderSearchBar = () => {
    const { searchText, isRefreshing } = this.state
    // const isDisabled = !this.isProductListViewReady()

    // if (p.op.isWeb()) {
    return (
      <HStack flex={1} minH='9' space='1' alignItems='center'>
        {this.renderSearchByBarcodeButton()}
        <XInput
          flex={1}
          // disabled={isDisabled}
          ref={this.searchTextRef}
          value={searchText}
          onChangeText={this._handleChangeSearchText}
          placeholder={this.getSearchTextPlaceholder()}
          onSubmitEditing={this._handleSubmitSearchByKeyboard}
          placeholderTextColor={COLORS.TEXT_INACTIVE}
          autoCapitalize='none'
          returnKeyType='search'
          // style={{ paddingLeft: 8, paddingRight: 8 }}
          px='1'
          InputLeftElement={
            <Box px='1'>
              <XIcon inactive name='search' />
            </Box>
          }
          InputRightElement={<ButtonClose isVisible={this.isSearchMode()} onPress={this._handleClearSearch} />}
        />
      </HStack>
    )
    // }

    // return (
    //   <HStack flex={1} alignItems='center'>
    //     {this.renderSearchByBarcodeButton()}
    //     <HStack flex={1} minH='9' space='1' alignItems='center'>
    //       <XInput
    //         flex={1}
    //         // disabled={isDisabled}
    //         ref={this.searchTextRef}
    //         value={searchText}
    //         onChangeText={this._handleChangeSearchText}
    //         placeholder={this.getSearchTextPlaceholder()}
    //         onSubmitEditing={this._handleSubmitSearchByKeyboard}
    //         placeholderTextColor={COLORS.TEXT_INACTIVE}
    //         autoCapitalize='none'
    //         returnKeyType='search'
    //         px='8'
    //         // style={{ paddingLeft: 8, paddingRight: 8 }}
    //       />
    //       <Box px='1' alignItems='center' justifyContent='center' position='absolute' left={0} top={0} bottom={0}>
    //         <XIcon inactive name='search' />
    //       </Box>
    //       <Box px='1' alignItems='center' justifyContent='center' position='absolute' right={0} top={0} bottom={0}>
    //         <ButtonClose isVisible={this.isSearchMode()} onPress={this._handleClearSearch} />
    //       </Box>
    //     </HStack>
    //   </HStack>
    // )
  }

  renderSearchByBarcodeButton = () => {
    if (!this.isSkuSearchAvailable() && !this.isUpcSearchAvailable()) {
      return null
    }

    // const { isBarcodeCameraVisible } = this.state
    // return (
    //   <Button
    //     // disabled={!this.isProductListViewReady()}
    //     onPress={this.openBarcodeCamera}
    //     // @ts-ignore
    //     style={StyleSheet.flatten({
    //       flex: 0,
    //       flexBasis: 'auto',
    //       height: 44,
    //       width: 44,
    //     })}>
    //     <XIcon activeDark={true} name='barcode-scan' family='MaterialCommunityIcons' />
    //     <XCamera
    //       title={`สแกนบาร์โค้ดเพื่อค้นหาสินค้า`}
    //       onBarcodeRead={this._onProductBarcodeScanned}
    //       onRequestClose={this.closeBarcodeCamera}
    //       isVisible={isBarcodeCameraVisible}
    //     />
    //   </Button>
    // )

    return (
      <BarcodeScannerModalButton
        btnStyle={[S.HEIGHT_40, S.WIDTH_40, { marginRight: 4 }]}
        saveStateKey={CONS.STATE_SAVE_KEYS.BARCODE_SCANNER_MODAL}
        headerTitle='สแกนบาร์โค้ดเพื่อค้นหาสินค้า'
        onBarcodeScanned={this._onProductBarcodeScanned}
      />
    )
  }

  // _onProductBarcodeScanned = async (barcodeText: string) => {
  _onProductBarcodeScanned = async (barcodeOutput: IBarcodeScannerOutput) => {
    // console.log('_onProductBarcodeScanned barcodeOutput => ', barcodeOutput)
    const barcodeText: string = barcodeOutput.data
    await util.setStatePromise(this, { isBarcodeSearching: true, searchText: barcodeText })
    await util.delay(200)
    this._enqueueSearch()
  }

  renderGoBackButton = () => {
    if (this.getIsGoBackButtonHidden()) {
      return null
    }
    return <NavHeaderButton backIcon onPressItem={this.goBack} />
  }

  // _onSortOptionsApplyWithSaveState = async (sortOptions: IProductListSortOptions) => {
  //   await util.setStatePromise(this, { sortOptions })
  //   await util.delay(200)
  //   this.doRefresh()
  // }

  // renderSortIconButton = () => {
  //   const { sortOptions } = this.state
  //   return (
  //     <VStack w='9' h='9' alignItems='center' justifyContent='center'>
  //       <ProductListSortIconButton
  //         // btnStyle={{ marginRight: 4 }}
  //         currentSortOptions={sortOptions}
  //         onApply={this._onSortOptionsApplyWithSaveState}
  //       />
  //     </VStack>
  //   )
  // }

  renderCustomHeader = () => (
    <VStack w='full' px='2' py='1' minH='11' justifyContent='center' _light={{ bg: NB.C.L.BG.CLEAR }} _dark={{ bg: NB.C.D.BG.CLEAR }}>
      <XStatusBar translucent backgroundColor='transparent' />
      <HStack w='full'>
        {this.renderGoBackButton()}
        {this.renderSearchBar()}
        {this.renderListViewModeButton()}
        {this.renderAddProductButton()}
        {/* {this.renderSortIconButton()} */}
        {this.renderFilterProductsButton()}
      </HStack>
    </VStack>
  )

  // renderHeaderBar = () => {
  //   return (
  //     <View style={S.HEADER_CONTAINER}>
  //       <View style={S.HEADER_BODY_LEFT}>
  //         <TouchableOpacity style={S.BUTTON_ICON} onPress={this.goBack}>
  //           <BackIcon size={STYLES.FONT_ICON_NORMAL} />
  //         </TouchableOpacity>
  //       </View>
  //       <View style={S.HEADER_BODY_CENTER}>
  //         <XText>{'title'}</XText>
  //       </View>

  //       <View style={S.HEADER_BODY_RIGHT}>
  //         <TouchableOpacity style={S.BUTTON_ICON}>
  //           <XIcon name='search' family='FontAwesome' size={STYLES.FONT_ICON_NORMAL} />
  //         </TouchableOpacity>
  //       </View>
  //     </View>
  //   )
  // }

  renderWatingSearchTypingInfo = () => {
    if (!this.isSearchMode() || this.isSearching()) {
      return null
    }

    const { isInitialized } = this.state

    if (!isInitialized) {
      return null
    }

    return (
      <Box my='4' p='2' alignItems='center' justifyContent='center'>
        <XText variant='inactive'>{`กรุณาพิมพ์ ${MINIMUM_SEARCH_TEXT_LENGTH} ตัวอักษรขึ้นไป เพื่อเริ่มการค้นหา`}</XText>
      </Box>
    )
  }

  // renderProductListFilterView = (children?: React.ReactNode) => {
  //   const { categoryList } = this.props
  //   const { catLevelCategoryList } = this.state
  //   return (
  //     <ProductListFilterView
  //       // ref={this.drawerCatRef}
  //       levelCategoryList={catLevelCategoryList}
  //       categoryList={categoryList.toJS()}
  //       // selectedCategory={catSeletedCategory}
  //       // submit={async (category: ISubmitDrawerCategory) => this._onSubmitProductListFilter(category)}
  //       onSubmit={this._onSubmitProductListFilter}>
  //       {children}
  //     </ProductListFilterView>
  //   )
  // }

  // แสดงเมื่อในร้านยังไม่มีสินค้าสักชิ้นเลย
  renderHaveNoProductItem = (noProductItemText: string) => (
    <View style={[S.COLUMN_CENTER, S.PADDING_8, { width: '100%', minHeight: 40, paddingTop: 20 }]}>
      <XText variant='inactive' textAlign='center'>
        {noProductItemText}
      </XText>
    </View>
  )

  renderMainProductListHaveNoProductItem = () => {
    if (this.state.mainProductCount !== 0) {
      return null
    }
    return this.renderHaveNoProductItem(this.getHaveNoProductItemText())
  }

  renderSearchProductListHaveNoProductItem = () => {
    if (this.state.searchProductCount !== 0) {
      return null
    }
    return this.renderHaveNoProductItem(this.getSearchProductListHaveNoProductItemText())
  }

  // showAlertFetchError = async (fetchErrorMessage) => {
  //   const errMessage = `${fetchErrorMessage.statusCode} ${fetchErrorMessage.statusMessage}`
  //   const isUserConfirm = await p.op.isUserConfirm(
  //     'เกิดข้อผิดพลาดในการโหลดข้อมูล',
  //     `${errMessage}\n\nกรุณาคิดลอกข้อผิดพลาดส่งมาให้ทีมงาน หากไม่ได้รับความสะดวกในการใช้งาน`,
  //     'คัดลอกข้อผิดพลาด',
  //     'ปิด'
  //   )
  //   if (isUserConfirm) {
  //     Clipboard.setString(errMessage)
  //     p.op.showToast(`คัดลอก ${errMessage} แล้ว`, 'success')
  //   }
  // }

  // แสดง error message จากการ fetch
  renderFetchErrorMessage = (fetchErrorMessage) => {
    const handleshowAlertFetchError = () => util.showAlertFetchError(fetchErrorMessage)
    // return (
    //   <View style={[S.COLUMN_CENTER, { width: '100%', minHeight: 40, paddingTop: 20 }]}>
    //     <View style={[S.ROW_CENTER]}>
    //       <XText style={[S.TEXT_INACTIVE, S.TEXT_ALIGN_CENTER]}>{'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'}</XText>
    //       <TouchableOpacity onPress={handleshowAlertFetchError}>
    //         <XIcon name='help-circle-outline' inactive={true} style={{ flex: 0, minWidth: 20, fontSize: STYLES.FONT_ICON_SMALLER }} />
    //       </TouchableOpacity>
    //     </View>
    //     <View style={[S.ROW_CENTER]}>
    //       <XText style={[S.TEXT_INACTIVE, S.TEXT_ALIGN_CENTER]}>
    //         {'หากกดปุ่มแล้วยังโหลดไม่สำเร็จ กรุณาปิดแอปแล้วเปิดใหม่ เพื่อลองอีกครั้ง'}
    //       </XText>
    //     </View>
    //     <View style={{ height: 12 }} />
    //     <TouchableOpacity
    //       onPress={this.doRefresh}
    //       style={[S.BUTTON_OUTLINE, S.BG_GREY, S.ROW_CENTER, S.PADDING_VERTICAL_4, S.PADDING_HORIZONTAL_12, { width: 100, height: 34 }]}>
    //       <XIcon
    //         name={'refresh'}
    //         family={'FontAwesome'}
    //         inactive={true}
    //         style={{ flex: 0, flexBasis: 'auto', minWidth: 0, height: STYLES.FONT_ICON_NORMAL, width: STYLES.FONT_ICON_NORMAL }}
    //       />
    //       <View style={[S.COLUMN_CENTER, S.PADDING_4]}>
    //         <XText style={[S.TEXT_ACTIVE]}>{'โหลดใหม่'}</XText>
    //       </View>
    //     </TouchableOpacity>
    //   </View>
    // )

    return <ErrorListItem onPressShowAlertInfo={handleshowAlertFetchError} onPressDoRefresh={this.doRefresh} />
  }

  renderMainListEmptyItem = () => {
    const { mainFetchErrorMessage } = this.state
    if (mainFetchErrorMessage) {
      return this.renderFetchErrorMessage(mainFetchErrorMessage)
    }

    return this.renderMainProductListHaveNoProductItem()
  }

  renderSearchListEmptyItem = () => {
    const { searchFetchErrorMessage } = this.state
    if (searchFetchErrorMessage) {
      return this.renderFetchErrorMessage(searchFetchErrorMessage)
    }

    return this.renderSearchProductListHaveNoProductItem()
  }

  _keyExtractor = (item: ProductListItemType, index: number) => `PLI_${index}_${item.id}`

  _onScrollBeginDrag = () => {
    this.isScrolling = true
  }

  _onScrollEndDrag = (evt) => {
    this.isScrolling = false
  }

  _onViewableItemsChanged = ({ viewableItems }) => {
    const fetchLimit = 20
    const { isRefreshing } = this.state
    if (this.isScrolling || this.isRefreshing || isRefreshing) {
      return
    }

    // console.log('_onViewableItemsChanged viewableItems => ', viewableItems)

    // console.log('_onViewableItemsChanged x => ', x)
    if (viewableItems.length > 0) {
      const focusItem = viewableItems[0]
      const isEmptyItem = focusItem.item.isEmpty || false
      if (isEmptyItem) {
        // const { isLoadingByOffset } = this.props.context
        const loadingItemIndex = focusItem.index
        const focusOffset = Math.floor(loadingItemIndex / fetchLimit) * fetchLimit
        // const isLoadingOffset = isLoadingByOffset[focusOffset] || false
        // fetch empty items
        console.log('_onViewableItemsChanged focusOffset => ', focusOffset)
        this._fetchItems({ offset: focusOffset })
      }
    }
  }

  renderListFooter = () => {
    const { isRefreshing, hasLoadMore } = this.state

    if (isRefreshing) {
      return <XSpinner my='2' size='sm' color={COLORS.TEXT_INACTIVE} />
    }

    if (hasLoadMore) {
      return <XSpinner my='2' size='sm' color={COLORS.TEXT_INACTIVE} />
    }

    if (this.getItemCount() === 0) {
      return null
    }

    return (
      <HStack w='full' p='2' alignItems='center' justifyContent='center'>
        <XText variant='inactive'>- สิ้นสุดรายการ -</XText>
      </HStack>
    )
  }

  _getRefreshControl = () => {
    if (p.op.isWeb()) {
      return null
    }

    const { isRefreshing } = this.state
    return <RefreshControl refreshing={isRefreshing} onRefresh={this._handleRefresh} />
  }

  renderMainList = () => {
    const { isInitialized, isRefreshing, searchProductListItems, mainProductListItems, hasLoadMore } = this.state

    if (!isInitialized) {
      return null
    }

    if (isRefreshing) {
      return (
        <VStack w='full' p='2' alignItems='center' justifyContent='center'>
          <XSpinner variant='inactive' />
        </VStack>
      )
    }

    const listItems = this.isSearchMode() ? searchProductListItems : mainProductListItems
    const listViewMode = this.getProductListViewMode()

    return (
      <FlatList<ProductListItemType>
        // key={`PL_${this.isSearchMode()}`}
        key={
          p.op.isWeb()
            ? `PL_${this.isSearchMode()}_${listViewMode}_${this.state.contentWidth}`
            : `PL_${this.isSearchMode()}_${listViewMode}`
        }
        // key={p.op.isWeb() ? `PL_${this.isSearchMode()}_${this.state.listColumns}` : `PL_${this.isSearchMode()}`}
        ref={this.mainListRef}
        refreshControl={this._getRefreshControl()}
        contentContainerStyle={p.op.isWeb() && listViewMode === 'grid' ? { paddingRight: 12 } : {}}
        data={listItems}
        renderItem={this.renderProductListItem}
        keyExtractor={this._keyExtractor}
        onEndReached={this._handleLoadMore}
        onEndReachedThreshold={0.8}
        removeClippedSubviews
        disableVirtualization
        initialNumToRender={12}
        maxToRenderPerBatch={18}
        viewabilityConfig={viewabilityConfig}
        // onViewableItemsChanged={this._onViewableItemsChanged}
        // onScrollEndDrag={this._onScrollEndDrag}
        // onScrollBeginDrag={this._onScrollBeginDrag}
        // numColumns={this.state.mainProductNumOfColumns}
        numColumns={listViewMode === 'grid' ? this.state.listColumns : 1}
        ListEmptyComponent={this.isSearchMode() ? this.renderSearchListEmptyItem() : this.renderMainListEmptyItem()}
        ListFooterComponent={this.renderListFooter()}
      />
    )

    // return (
    //   <InfiniteList<ProductListItemType>
    //     key='ProductListMain'
    //     isHidden={this.isHiddenMainProductList()}
    //     ref={this.mainListRef}
    //     renderItem={this.renderProductListItem}
    //     onFetchItems={this.fetchMainProducts}
    //     onChangeTotalCount={this._onChangeMainProductCount}
    //     onChangeNumOfColumns={this._onChangeProductListNumOfColumns}
    //     fetchLimit={CONS.PRODUCTS_FETCH_LIMIT_MORE}
    //     itemWidth={PRODUCT_LIST_ITEM_WIDTH}
    //     // style={{
    //     //   backgroundColor: COLORS.BG_LIGHT_GREY,
    //     // }}
    //     // contentContainerStyle={{
    //     //   paddingTop: 4,
    //     //   paddingBottom: 12,
    //     // }}
    //     ListEmptyComponent={this.renderMainListEmptyItem()}
    //   />
    // )
  }

  renderSearchList = () => {
    return null

    const { isInitialized } = this.state

    if (!isInitialized) {
      return null
    }

    return (
      <InfiniteList<ProductListItemType>
        key='ProductListSearch'
        isHidden={this.isHiddenSearchProductList()}
        ref={this.searchListRef}
        renderItem={this.renderProductListItem}
        onFetchItems={this.fetchSearchProducts}
        onChangeTotalCount={this._onChangeSearchProductCount}
        fetchLimit={CONS.PRODUCTS_FETCH_LIMIT_MORE}
        itemWidth={PRODUCT_LIST_ITEM_WIDTH}
        // style={{
        //   backgroundColor: COLORS.BG_LIGHT_GREY,
        // }}
        // contentContainerStyle={{
        //   paddingTop: 4,
        //   paddingBottom: 12,
        // }}
        ListEmptyComponent={this.renderSearchListEmptyItem()}
      />
    )
  }

  // renderVerticalSeparator = (height: number) => {
  //   return <View style={{ height, width: '100%' }} />
  // }

  // renderMain = () => this.renderProductListFilterView(this.renderContainer(this.renderContent()))

  renderMain = () => this.renderContainer(this.renderContent())

  renderContainer = (content) => <XContainer>{content}</XContainer>

  _onContentLayout = (event: LayoutChangeEvent) => {
    const { width } = event.nativeEvent.layout
    if (p.op.isWeb() && width > 0 && width !== this.contentWidth) {
      this.contentWidth = width - 12 // paddingRight
      this.setState({ contentWidth: width, listColumns: this._computeListColumns() })
      this.listItemWidth = this._computeListItemWidth()
    }
  }

  _computeListColumns = () => {
    let expectedMinCol = 3 // default

    if (this.contentWidth <= 400) {
      expectedMinCol = 3
    } else if (this.contentWidth > 400 && this.contentWidth <= 500) {
      expectedMinCol = 3
    } else if (this.contentWidth > 600 && this.contentWidth <= 900) {
      expectedMinCol = 4
    } else if (this.contentWidth > 900 && this.contentWidth <= 1100) {
      expectedMinCol = 5
    } else if (this.contentWidth > 1100 && this.contentWidth <= 1400) {
      expectedMinCol = 5
    }

    return expectedMinCol
  }

  _computeListItemWidth = () => {
    const expectedMinCol = this._computeListColumns()
    return Math.floor(this.contentWidth / expectedMinCol)
  }

  // ถ้าต้องการจัด content ใหม่ ปรับตรงนี้
  renderContent = () => (
    <VStack flex={1} w='full' onLayout={this._onContentLayout}>
      {this.renderCustomHeader()}
      {this.renderSearchInfoBar()}
      {this.renderCatListBar()}
      <VStack w='full' flex={1} _light={{ bg: 'coolGray.200' }} _dark={{ bg: 'warmGray.700' }}>
        {/* {this.renderWatingSearchTypingInfo()} */}
        {this.renderMainList()}
        {/* {this.renderSearchList()} */}
      </VStack>
      {/* {this.renderProductListFilterView()} */}
    </VStack>
  )

  // renderMainWithCategoryFilter = () => {
  //   return this.renderProductListFilterView(this.renderMain())
  // }

  render() {
    // const { isInitialized } = this.state

    // if (!isInitialized) {
    //   return null
    // }

    return this.renderMain()
  }
}

const s = {
  GRID_CONTAINER: {
    flex: 1,
    minHeight: 44,
  },
  GRID_COL_MIDDLE_CENTER: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  GRID_COL_MIDDLE_RIGHT: {
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  HEADER_COL_ICON: {
    flex: 0,
    minWidth: 54,
  },
  CUSTOM_HEADER: {
    backgroundColor: '#fff',
    paddingLeft: 2,
    paddingRight: 2,
    height: 54,
    marginTop: 0,
    paddingTop: 0,
    ...Platform.select({
      // android: {
      //   marginTop: getStatusBarHeight(true),
      // },
      // ios: {
      //   marginTop: isIphoneX() ? getStatusBarHeight() - 4 : undefined,
      // },
      web: {
        height: CONS.SPECIFIC_PLATFORM.WEB.HEADER_HEIGHT, // NAV_HEADER_HEIGHT
      },
    }),
  },
}

export default BaseUIProductListView
